import(/* webpackMode: "eager" */ "/root/repo/src/app/referral/page.tsx");
